import { Card, CardContent, Grid, makeStyles } from '@material-ui/core'
import { COLORS } from 'src/utils/Themes/colors'
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord'

const PolicyCoverages = ({
  coverageTypes,
  coverageTypes_array,
  policyCoverageHeading,
}) => {
  const classes = useStyles()

  return (
    <div className='policyDocumentParent'>
      <div className={classes.upcomingRenewalsWrapper}>
        <Card classes={{ root: classes.root }}>
          <CardContent classes={{ root: classes.contentRoot }}>
            <div className={classes.renewalsItemWrapper}>
              <div className={classes.renewalsContent}>
                <div>
                  <div className={classes.policyCoverageDiv}>
                    <p className={classes.heading}>{policyCoverageHeading}</p>
                  </div>
                  {coverageTypes !== '' && coverageTypes != null ? (
                    <>
                      {coverageTypes_array?.map((coverageType) => {
                        return (
                          <Grid
                            item
                            className={classes.policyCoverageContent}
                            key={`coverage_${coverageType}`}
                          >
                            <FiberManualRecordIcon className={classes.dotPic} />
                            <p className={classes.policycoveragestext}>
                              {coverageType}
                            </p>
                          </Grid>
                        )
                      })}
                    </>
                  ) : null}
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

export default PolicyCoverages
const useStyles = makeStyles({
  upcomingRenewalsWrapper: {
    marginTop: '0px',
  },
  root: {
    borderRadius: '10px',
  },
  renewalsItemWrapper: {
    alignItems: 'center',
    height: '170px',
    overflow: 'auto',
  },
  dotPic: {
    width: '4px',
    marginRight: '5px',
  },
  contentRoot: {
    padding: 0,
    '&:last-child': {
      padding: 0,
    },
  },
  renewalsContent: {
    width: '100%',
    flexGrow: 1,
  },
  renewalsItem: {
    borderBottom: `0.7px solid ${COLORS.GREY_11}`,
    display: 'flex',
    alignItems: 'center',
    height: '50px',
    padding: '9px 10px',
    '&:last-child': {
      borderBottom: '0px solid',
    },
  },
  heading: {
    margin: '10px 0px',
    color: COLORS.DARK_PINK,
    fontWeight: 'bold',
    paddingTop: '10px',
  },
  policycoveragestext: {
    margin: '0px 0px',
    fontSize: '14px',
    color: COLORS.MEDIUM_BLUE,
  },
  policyCoverageContent: {
    display: 'flex',
    paddingLeft: '25px',
    fontSize: '14px',
    textAlign: 'initial',
    paddingBottom: '5px',
  },
  policyCoverageDiv: {
    display: 'flex',
    justifyContent: 'center',
    gap: '15px',
  },
})
